import type { App } from "app/App";
import type { RewardChestPopupConfig } from "game/views/popups/RewardChestPopup";
import { RewardChestPopup } from "game/views/popups/RewardChestPopup";

export function openRewardChestPopup(app: App, config: RewardChestPopupConfig): Promise<void> {
  return new Promise((resolve) => {
    const {
      controller: { popups },
    } = app;
    
    const popup = new RewardChestPopup(config);

    popup.onCollectClicked.connect(async () => {
      await popup.animateCollect();
      resolve();
    });

    void popups.addPopup({
      popupInstance: popup,
      settings: {
        hideRays: true,
        clearStack: true,
      },
    });
  });
}